export const domData = {
    order: 2,
    name: 'dom',
    title: 'Dom',
    iconSrc: 'pic_dom.svg',
    headlineText: 'Mniej często znaczy więcej!  Zobacz, jak wprowadzić ekologię do swojego domu.',
    mainText:
        'Minimalizm jest eko! Mniej rzeczy to mniej sprzątania, mniej do uporządkowania, mniejszy bałagan… I mniej śmieci. Oszczędne życie wcale nie równa się małej zamożności, ale jest oznaką rozwagi i mądrego użytkowania dobrami. Co zrobić, aby wprowadzić ekologię do swojego domu?',
    mainVideoSrc:
        '<iframe width="560" height="315" src="https://www.youtube-nocookie.com/embed/8Ae74sOKxeE" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
    odpadySection: [
        {
            text:
                'Od zwykłych ściereczek bardziej ekologiczne będą te z mikrofibry, a najlepszym rozwiązaniem jest użycie starych ręczników czy prześcieradeł jako ścierek.',
        },
        {
            text:
                'Jeśli lubisz czytać, korzystaj z bibliotek lub e-booków i czytników elektronicznych. Druk książek stanowi spory odsetek przemysłu papierniczego.',
        },
        {
            text:
                'Chcesz zaimponować komuś prezentem urodzinowym? Spróbuj przygotować coś własnoręcznie! Zaoszczędzić można również na torbach na prezenty czy na papierze ozdobnym, gdyż często można wykorzystać go ponownie. Można też zrezygnować z pakowania niektórych prezentów.',
        },
        {
            text:
                'Słyszałeś już o upcyklingu? Upcykling przedmiotów to nadawanie im nowego życia w zupełnie innej formie – w ten sposób pudełka po butach stają się pojemnikami do przechowywania rzeczy, kubeczki plastikowe zostają przeznaczone do przechowywania dziecięcych kredek, a puszkę przekształcamy w doniczkę.',
        },
        {
            text: '',
            picSrc: 'pics/pic-17.png',
            caption:
                'Ozdoby: Stare przedmioty można wykorzystać w zupełnie nowy sposób aby nadać charakter wnętrzu. Lampa ze starej butelki, wazon znaleziony na targu staroci czy samodzielnie namalowany obraz – dlaczego nie? Upcycling daje Ci nieograniczone możliwości!',
        },
        {
            text:
                'Stare meble można odnawiać! Jeśli twoja komoda niekoniecznie cieszy oko, z łatwością i za małe pieniądze możesz dać jej drugie życie – użyj do tego farby i nowych uchwytów, a w fotelu zmień obicie. Ciekawe i stylowe meble można też stworzyć ze starych desek, palet czy drewnianych skrzyń na owoce.',
        },
        {
            text: '',
            picSrc: 'pics/pic-15.png',
            caption:
                'Meble: Czy każdy stary, lekko zniszczony mebel lub sprzęt kuchenny jest bezużyteczny? Zdecydowanie nie! Sprzęty możemy odświeżyć i w ten sposób dać im nowe, dłuższe życie. Starą kanapę oddaj do renowacji, meblościankę po babci odmaluj i dodaj nowe gałki, a stolik pod tv zrób ze skrzynek po jabłkach.',
        },
        {
            text:
                'Nie wyrzucaj starych koców, prześcieradeł czy poszewek – możesz oddać je np. do schroniska dla zwierząt, zaś nakrętki od napojów oddaj do specjalnych punktów zbiórki, które zazwyczaj wspierają akcje charytatywne.',
        },
        {
            text:
                'W Jastrzębiu-Zdroju powstał punkt selektywnego zbierania odpadów oraz gminny punkt zbierania odpadów komunalnych.  Korzystaj z nich i pamiętaj o segregacji!',
        },
        {
            text: '',
            picSrc: 'pics/pic-14.png',
            caption:
                '1. Reduce - ogranicz<br /> 2. Reuse – użyj ponownie<br /> 3. Recycle - odzyskaj',
        },
        {
            text:
                'Bierz udział w akcjach „sprzątanie świata” organizowanych przez Jastrzębie! W ten sposób możesz aktywnie przyczynić się do działań prośrodowiskowych.',
        },
    ],
    klimatSection: [],
    energiaSection: [
        {
            text:
                'Oszczędzaj energię, gdzie tylko się da. Zamiast suszyć pranie mechanicznie, rozwieś je na suszarce i pozwól wyschnąć samodzielnie. Zamiast odkurzacza użyj miotły czy zmiotki, a pościeli czy ręczników nie prasuj.',
        },
    ],
    powietrzeSection: [],
    wodaSection: [
        {
            text:
                'Sprzątaj ekologicznie – na początek ogranicz, a potem całkiem pozbądź się sztucznych detergentów. Wykorzystaj np. octet, szare mydło i olejki eteryczne.',
        },
    ],
    czyWieszSection: [
        {
            text:
                '...do dokładnego wyczyszczenia całego mieszkania wcale nie potrzebujesz dziesięciu różnych detergentów, które drażniąco działają na drogi oddechowe i skórę?... ',
            more:
                'Wystarczy jeden ręcznie przygotowany środek czyszczący, a w ekstremalnych przypadkach warto w pierwszej kolejności sięgnąć po naturalne rozwiązania (np. ocet świetnie sprawdzi się w walce z pleśnią, a cytryna pomoże pozbyć się rdzy).',
        },
        {
            text:
                '...w Internecie możesz znaleźć całą masę pomysłów na zrobienie rzeczy samemu?...',
            more:
                'DIY, czyli zrób to sam, to idea związana z samodzielnym i niekomercyjnym wykonywaniem różnych prac na potrzeby własne, bez pomocy fachowców. Często tego typu rozwiązania wiążą się z niższym kosztem niż gdybyśmy skorzystali z ofert proponowanych przez sieciówki.',
        },
        {
            text:
                '...w Polsce sprzedaje się jeden telewizor co 15 sekund, co daje ponad 2,1 miliona telewizorów rocznie?...',
            more:
                'Jeśli zaś chodzi o duże urządzenia AGD, w ciągu roku sprzedaje się ich blisko 6 milionów sztuk, a małego AGD aż 12 milionów! Pierwsze na tej liście są pralki, lodówki oraz kuchenki mikrofalowe. Czy  rzeczywiście konieczne jest, aby tak często wymieniać urządzenia domowego użytku?' +
                '<br /><br /><a target="_blank" rel="noopener noreferrer" href="https://imagazine.pl/2019/02/11/w-polsce-sprzedaje-sie-jeden-telewizor-co-15-sekund/">https://imagazine.pl/2019/02/11/w-polsce-sprzedaje-sie-jeden-telewizor-co-15-sekund/</a>',
        },
    ],
};
